<template>
  <div class="business-news-post">
    <div
      :class="[
        'section-title d-flex justify-content-between align-items-center',
        darkClass && 'title' in darkClass ? darkClass.title : '',
      ]"
    >
      <h3 class="title">市场验证案例</h3>
      <router-link to="/articles?channel=4">查看更多</router-link>
    </div>
    <div class="business-post">
      <template v-for="(data, index) in TrendingPosts">
        <div
          :key="index"
          :class="[
            'business-post-item  mb-40',
            darkClass && 'item' in darkClass ? darkClass.item : '',
          ]"
        >
          <divide-card v-if="data" :readMore="true" stype="row" :datas="data" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import DivideCard from "../Utility/Cards/DivideCard.vue";
export default {
  components: { DivideCard },
  inject: ['dataWrapper', 'fetchStatus'],
  props: {
    darkClass: {
      type: Object,
    },
  },
  data: () => ({
    TrendingPosts: [],
  }),
  watch: {
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          this.TrendingPosts = Array.isArray(this.dataWrapper.articles) 
            ? this.dataWrapper.articles.filter(item => item.orgchannel === '4').slice(0, 4) 
            : [];
        }
      },
      immediate: true,
      deep: true
    }
  },
};
</script>

<style>
</style>